// Live-Punkte-Berechnung — identische Logik wie SQL `score_game`.
// Wird im Frontend genutzt, um während laufender Spiele provisorische Punkte
// für den User-Tipp anzuzeigen.

export function calcPoints(
  homeScore: number | null | undefined,
  awayScore: number | null | undefined,
  homeTip: number | null | undefined,
  awayTip: number | null | undefined,
): number {
  if (homeScore == null || awayScore == null || homeTip == null || awayTip == null) return 0;
  const resDiff = homeScore - awayScore;
  const tipDiff = homeTip - awayTip;
  const resWinner = resDiff > 0 ? 1 : resDiff < 0 ? -1 : 0;
  const tipWinner = tipDiff > 0 ? 1 : tipDiff < 0 ? -1 : 0;
  if (homeTip === homeScore && awayTip === awayScore) return 4;
  if (tipDiff === resDiff) return 3;
  if (tipWinner === resWinner) return 2;
  return 0;
}

const LIVE_STATUSES = new Set(["1H", "HT", "2H", "ET", "BT", "P", "LIVE"]);
export function isLiveStatus(s?: string | null): boolean {
  return !!s && LIVE_STATUSES.has(s);
}
